import React, { FC } from "react"
import { RouteComponentProps } from "@reach/router"
import _ from "lodash"
import Subnav from "components/subnav"
import { Container_s } from "styles/app-styles"

interface Route {
  hard?: boolean,
  name: string,
  link: string
}

const MixedUse: FC<RouteComponentProps> = (props) => {
  let rentRollRoute = {name: "MF Rent Roll", link: "/n/mixed-use/mf-rent-roll", hard: false}
  let lineItemsRoute = {name: "Line Items", link: "/n/mixed-use/line-items", hard: false}
  let inflationRoute = {name: "Inflation", link: "/n/mixed-use/inflation", hard: false}
  let areaMeasureRoute = {name: 'Area Measures', link: "/n/mixed-use/area-measures", hard: false}

  let tabs: Route[] = [
    rentRollRoute,
    lineItemsRoute,
    inflationRoute,
    areaMeasureRoute
  ]

  return (
    <Container_s>
      <Subnav section="MIXED USE: MULTIFAMILY" tabs={tabs}/>
      <div style={{paddingTop: '72px'}}>
        {props.children}
      </div>
    </Container_s>
  )
}

export default MixedUse
